export const NAME = 'ARTICLES';

export const articleFavouriteList = (store) =>
  store[NAME].favouriteList.data || [];
export const articleFavouritePageMeta = (store) =>
  store[NAME].favouriteList.page || {};
export const getPaginatedFavouriteArticles = (store) =>
  store[NAME].favouriteList.allData || [];
